import { useRouterHistory } from 'react-router';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import { History } from 'history';
import { parse, stringify } from 'qs';

// eslint-disable-next-line react-hooks/rules-of-hooks
const createAppHistory = useRouterHistory(createBrowserHistory);
export const history: History = createAppHistory({
  parseQueryString: parse,
  stringifyQuery: stringify,
});

export default history;
